<template>
  <main class="offer-details u-container pb-10">
    <component
      :is="templateComponent"
      v-if="offsrc && offer && templateComponent"
      :ad-id="offer.id"
      :ad-group-id="offer.adGroupId"
      :account-id="offer.accountId"
      :template-id="template.id"
      :apple-pass="template.properties.applePass"
      :background-url="template.properties.backgroundUrl"
      :background-url-two="template.properties.backgroundUrlTwo"
      :background-url-three="template.properties.backgroundUrlThree"
      :barcode="template.properties.barcode"
      :barcode-two="template.properties.barcodeTwo"
      :barcode-three="template.properties.barcodeThree"
      :cta="template.properties.cta"
      :cta-two="template.properties.ctaTwo"
      :cta-url="template.properties.ctaUrl"
      :expiration="template.properties.expiration"
      :fixed="template.properties.fixed"
      :google-pass="template.properties.googlePass"
      :headline="template.properties.headline"
      :headline-two="template.properties.headlineTwo"
      :headline-three="template.properties.headlineThree"
      :legal-text="template.properties.legalText"
      :legal-text-two="template.properties.legalTextTwo"
      :legal-text-three="template.properties.legalTextThree"
      :logo-url="template.properties.logoUrl"
      :logo-url-two="template.properties.logoUrlTwo"
      :logo-url-three="template.properties.logoUrlThree"
      :promo-code="template.properties.promoCode"
      :promo-code-two="template.properties.promoCodeTwo"
      :promo-code-three="template.properties.promoCodeThree"
      :promo-code-label="template.properties.promoCodeLabel"
      :promo-code-label-two="template.properties.promoCodeLabelTwo"
      :promo-code-label-three="template.properties.promoCodeLabelThree"
      :tagline="template.properties.tagline"
      :tagline-two="template.properties.taglineTwo"
      :tagline-three="template.properties.taglineThree"
    />
  </main>
</template>

<script>
import {
  AdvantageMobileFullPageDefault,
  AdvantageMobileFullPageExpanded,
} from '@ampersend/mgo';
import offerDetailsMixin from './mixin';

export default {
  name: 'OfferDetails',
  components: {
    AdvantageMobileFullPageDefault,
    AdvantageMobileFullPageExpanded,
  },
  mixins: [offerDetailsMixin],
};
</script>
